let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3uUSO")).then(() => parcelRequire('2fak7'));